export const baseInputProps = {
  label: String,
  labelForId: String,
  isFocused: Boolean,
  isTextarea: Boolean,
  isError: Boolean,
  disabled: Boolean,
} as const;
